export default "__VITE_ASSET__1496d0f3__"